import(/* webpackMode: "eager" */ "/home/u336510025/domains/done2go.com/public_html/.builds/source/done2go/src/app/impressum/page.tsx");
